function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBmw(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "40px",
    height: "40px",
    viewBox: "0 0 40 40",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("text", {
    x: 7,
    y: 25,
    style: {
      fill: "#009ADA",
      font: "10px Helvetica"
    }
  }, "\n    BMW\n  "));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBmw);
export default __webpack_public_path__ + "static/media/bmw.c803ea82aacde8648d3673945a7ec7a4.svg";
export { ForwardRef as ReactComponent };